// @flow
import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';

import CCButton from './CCButton';
import CloseButton from './CloseButton';
import KeyboardButton from './KeyboardButton';

import AudioRecorder from '../AudioRecorder';

import { isMobile } from '../../utils';
import { isConversationEnded, isDefaultRoomId } from '../../utils/ws-v1';

const useStyles = makeStyles({
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 101,
    display: 'flex',
    flexDirection: 'column',
    width: 70,
    marginTop: 20,
    '& > :not(:last-child)': {
      marginBottom: 20,
    },
  },
});

interface Props {
  onKeyboardButtonClick: Function;
  onEndConversationClick: Function;
  inTwilioCalls: boolean;
  isInConversation: boolean;
  muted: boolean;
  scribe: boolean;
  status: Object;
  user: Object;
  currentPlatform: string;
  displayable: Object;
  inConferenceCall: boolean;
  lightView: boolean;
  fullScreen: boolean;
}

const ConversationButtons = ({
  onKeyboardButtonClick,
  onEndConversationClick,
  inTwilioCalls,
  isInConversation,
  muted,
  scribe,
  status,
  user,
  currentPlatform,
  displayable,
  inConferenceCall,
  lightView,
  fullScreen,
}: Props) => {
  const classes = useStyles();

  const showKeyboardButton =
    currentPlatform === 'web' &&
    !muted &&
    !lightView &&
    !scribe &&
    !fullScreen &&
    !inConferenceCall &&
    !inTwilioCalls &&
    isInConversation;

  const showMicrophoneButton = displayable.audio && !muted && isInConversation && !scribe;

  const showCCButton =
    (!status.participants || isInConversation) &&
    currentPlatform === 'web' &&
    status.participants &&
    !fullScreen &&
    !scribe &&
    !isDefaultRoomId(status.id) &&
    !isMobile() &&
    !window.isElectron;

  const isCCButtonDesktop =
    currentPlatform === 'web' && status.participants && !scribe && !isDefaultRoomId(status.id) && window.isElectron;

  const showCloseButton =
    currentPlatform === 'web' && status.participants && !scribe && !fullScreen && !isDefaultRoomId(status.id);

  if (!isInConversation) return null;

  return (
    <div className={classes.container}>
      {showMicrophoneButton && <AudioRecorder conversationEnded={isConversationEnded(status, user)} />}
      {showKeyboardButton && <KeyboardButton onClick={onKeyboardButtonClick} />}
      {showCCButton && <CCButton />}
      {isCCButtonDesktop && <CCButton isDesktop />}
      {showCloseButton && <CloseButton onEndConversationClick={onEndConversationClick} />}
    </div>
  );
};

const mapStateToProps = ({
  scribeConversation: { inTwilioCalls, isInConversation, muted, scribe, status },
  scribeSession: { captioner, currentPlatform, displayable, inConferenceCall, lightView },
  scribeTranscriptUI: { fullScreen },
}) => ({
  inTwilioCalls,
  isInConversation,
  muted,
  scribe,
  status,
  user: captioner,
  currentPlatform,
  displayable,
  inConferenceCall,
  lightView,
  fullScreen,
});

export default connect(mapStateToProps)(ConversationButtons);
